import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { sweetAlert } from "../../Common/Utills/Utills";

//   import UpdatePartyName from "./UpdatePartyName";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import { CSSTransition } from "react-transition-group";
import AddTKCSRateList from "./AddTKCSRateList";
import UpdateTKCSRateList from "./UpdateTKCSRateList";
import _ from "lodash";

const TKCSRateList = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [storeProduct, setStoreProduct] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState("");

  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };
  const toggleSearch = () => {
    setShowSearch(!showSearch); // Toggle the state to show/hide search input field
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    party_name: "",
    location: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => {
      return {
        ...prevFilterCriteria,
        [name]: value,
      };
    });

    if (name === "product_name") {
      setSelectedProductName(value);
    }
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/tkcs-rate/all-tkcs-rate-list/${user_id}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }, []);

  const deleteRow = async (id) => {
    const message = "Do you want to delete this TKCS rate!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL = SERVER_URL + `/api/tkcs-rate/tkcs-rate-list/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
        };
      });
      getData();
    } else {
      toast.error(response.message);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
        };
      });
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };

  const updateData = async (rowData) => {
    const { id, discom_name } = rowData;
    let BASE_URL = SERVER_URL + `/api/discom/discom-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        discom_name,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 150,
    },
    {
      headerName: "Party Name",
      field: "party_name",
      editable: false,
      width: 205,
    },
    {
      headerName: "Location/Circle",
      field: "location",
      editable: false,
      width: 205,
    },
    {
      headerName: "Product Name",
      field: "product_name",
      editable: false,
      width: 205,
    },
    {
      headerName: "TKCS Rate",
      field: "tkcs_rate",
      editable: false,
      width: 205,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#updateModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ party_name: "", location: "" });
    setSelectedProductName("");
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getProductData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };
  useEffect(() => {
    getProductData();
  }, [selectedProductName]);
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            TKCS Rate List Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add TKCS Rate
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    type="text"
                    className="form-control form-control-lg"
                    name="product_name"
                    id="size"
                    onChange={(e) =>
                      handleFilterChange("product_name", e.target.value)
                    }
                    value={selectedProductName}
                  >
                    <option value="">Select All Product Name</option>
                    {storeProduct?.map((item, id) => {
                      return (
                        <option
                          value={item.size}
                          key={id}
                        >{`${item.size}`}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-3" style={{ display: "flex" }}>
                {/* <button
                    className="btn btn-outline-primary"
                    onClick={toggleSearch} 
                  >
                    <span className="mr-1">
                      <i className="mdi mdi-magnify" /> 
                    </span>
                    Search
                  </button> */}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Party name"
                  value={filterCriteria.party_name}
                  onChange={(e) =>
                    handleFilterChange("party_name", e.target.value)
                  }
                />
              </div>
              <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Location/Circle"
                  value={filterCriteria.location}
                  onChange={(e) =>
                    handleFilterChange("location", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddTKCSRateList
            //   setimgfile={setimgfile}
            formRef={formRef}
            getData={getData}
          />
          <UpdateTKCSRateList
            selectedRowsData={selectedRowsData}
            setselectedRowsData={setselectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default TKCSRateList;
